<template>
  <div class="">
    <el-dialog
      title="Hướng dẫn tìm ID"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div class="content">
        <img class="img" :src="gameImg" alt="" srcset="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      content: "",
      gameImg: require("@/assets/demo.png"),
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleClose(done) {
      done();
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-dialog {
  width: 30%;
}
.content {
  height: 100%;
  overflow: auto;
}
.title {
  text-align: left;
  font-size: 16px;
  margin: 10px 0;
}
.img {
  width: 100%;
}
@media (max-width: 1200px) {
  /deep/ .el-dialog {
    width: 80%;
  }
}
</style>
